import Manifesto from "./dependable-professionals-manifesto.md";
import UnlockCareer from "./unlock-career-opportunities-tanzania.md";
import MissOpportunities from "./why-job-seekers-miss-opportunities.md";

export const articles = [
	{
		title: "It Takes All of Us: How We Can Unlock Career Opportunities for Young Tanzanians",
		slug: "unlock-career-opportunities-tanzania",
		content: UnlockCareer,
		excerpt:
			"When we talk to young job seekers across Tanzania—students, graduates, early professionals—one thing stands out. They don’t want favors. They want a fair shot.",
		date: "2024-06-12",
	},
	{
		title: "We Are Dependable Professionals: A Manifesto for Tanzania’s Job Seekers",
		slug: "dependable-professionals-manifesto",
		content: Manifesto,
		excerpt:
			"In every corner of Tanzania, thousands of young people are dreaming of a better future — a fulfilling career, a steady income, a life of contribution and purpose. But dreams alone are not enough.",
		date: "2024-06-12",
	},
	{
		title: "Why Most Job Seekers Miss Great Opportunities—and How to Fix It",
		slug: "why-job-seekers-miss-opportunities",
		content: MissOpportunities,
		excerpt:
			"If you’re searching for a job in Tanzania, you’re not alone. But what may surprise you is how many great opportunities are being missed—every single day. Not because candidates are not qualified. But because most people don’t even know those jobs exist.",
		date: "2024-06-12",
	},
];
